import { observable, action, computed, flow, toJS } from 'mobx';
import Util from 'utils';
import Config from 'config/Config';
import Stores from 'config/Stores';
import Serv from './AccoumulateServ';

class AccoumulateMod {
  @observable showInfo = {};
  @observable tipContent = {};

  /**
   * 修改参数逻辑
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  getCardTypeDetail = flow(function* (id) {
    try {
      const { data, resultCode } = yield Serv.getCardTypeDetail(id);
      if (+resultCode === 0) {
        this.showInfo = data;
      }
    } catch (error) {}
  });

  // 上报点击
  submitTapUpdate = flow(function* (status) {
    if (!status && status !== 0) return;
    try {
      const res = yield Serv.submitTapUpdate(status);
      return res;
    } catch (error) {}
  });

  // 上报会员升级优惠券提醒状态接口
  submitCouponUpdate = flow(function* (id) {
    if (!id) return;
    try {
      const res = yield Serv.submitCouponUpdate(id);
      return res;
    } catch (error) {}
  });
}

export default AccoumulateMod;



// WEBPACK FOOTER //
// ./src/widget/AccoumulateV2/AccoumulateMod.js